/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Link } from "@material-ui/core";
import GridCardImage from "./GridCardImage";
import GridCardAreaAndConfig from "./GridCardAreaAndConfig";
import GridCardChips from "./GridCardChips";
import GridCardPrice from "./GridCardPrice";
import GridCardBuilder from "./GridCardBuilder";
import GridCardLocation from "./GridCardLocation";
import GridCardButtons from "./GridCardButtons";
import GridCardTitle from "./GridCardTitle";

/* Data Imports */

import GridCardAreaData from "../placeholder-data/GridCardAreaData";
import GridCardPriceData from "../placeholder-data/GridCardPriceData";
import GridCardChipsData from "../placeholder-data/GridCardChipsData";
import GridCardConfigData from "../placeholder-data/GridCardConfigData";
import GridCardBHKData from "../placeholder-data/GridCardBHKData";
// import AppConfig from "../../../../AppConfig";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  gridCardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      width: "100%",
      height: "24rem",
      margin: "0.5rem 0% 0.5rem 0%",
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      height: "26rem",
      margin: "0.5rem 0% 0.5rem 0%",
    },
    /* XSSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 170)]: {
      width: "100%",
      height: "31rem",
      margin: "0.5rem 0.5% 0.5rem 0.5%",
    },
    /* XSSMSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 130)]: {
      width: "100%",
      height: "36rem",
      margin: "0.5rem 0.5% 0.5rem 0.5%",
    },
    /* XSSMSMSM breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.sm - 60)]: {
      width: "49%",
      height: "25rem",
      margin: "0.5rem 0.5% 0.5rem 0.5%",
    },
    [theme.breakpoints.up("sm")]: {
      width: "49%",
      height: "27rem",
      margin: "0.5rem 0.25% 0.5rem 0.25%",
    },
    /* SMMD Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.md - 80)]: {
      width: "32.33%",
      height: "27rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    [theme.breakpoints.up("md")]: {
      width: "32.33%",
      height: "26rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* MDLG Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg - 240)]: {
      width: "32.33%",
      height: "27rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "32.33%",
      height: "27rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* LGXL Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl - 500)]: {
      width: "32.33%",
      height: "32rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* LGXLXL Breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl - 50)]: {
      width: "32.33%",
      height: "36rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "32.33%",
      height: "27rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XLXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 80)]: {
      width: "32.33%",
      height: "34rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      width: "32.33%",
      height: "29rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXLXXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 670)]: {
      width: "32.33%",
      height: "36rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXLXXXLXXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1280)]: {
      width: "32.33%",
      height: "42rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXLXXXLXXXLXXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1780)]: {
      width: "32.33%",
      height: "44rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      width: "32.33%",
      height: "32rem",
      margin: "0.5rem 0.167% 0.5rem 0.167%",
    },
    borderRadius: "4px",
    boxShadow:
      "0px 0px 2px rgb(0 0 0 / 14%), 0px 2px 2px rgb(0 0 0 / 12%), 0px 1px 3px rgb(0 0 0 / 20%)",
    color: "#202020",
    "&:hover": {
      textDecoration: "none",
    },
  },
  gridCardInfoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "0.5rem 1rem 0.5rem 1rem",
    width: "100%",
    height: "100%",
    borderRadius: "4px",
  },
}));

const GridCard = (props) => {
  const shareButtonClickListener = (event) => {
    event.preventDefault();
    window.location.hash = "#share-" + props.slug;
  };
  const pdfButtonClickListener = (event) => {
    event.preventDefault();
    window.location.hash =
      "#download@" +
      props.slug +
      "@" +
      props.pdfHref +
      "@" +
      props.title +
      "@" +
      props.pdf;
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <Link
        href={"/properties/" + (props.slug ? props.slug : "")}
        rel="noopener"
        title={props.title ? props.title : "Unknown Property"}
        className={classes.gridCardContainer}
      >
        <GridCardImage
          loading={props.loading}
          imageSrc={
            props.imageSrc
              ? props.imageSrc
              : "/images/other/placeholder_1080p.jpg"
          }
        />
        <div className={classes.gridCardInfoContainer}>
          <GridCardTitle
            loading={props.loading}
            title={props.title ? props.title : "Unknown Property"}
          />
          <GridCardLocation
            loading={props.loading}
            location={props.location ? props.location : "Unknown Location"}
          />
          <GridCardBuilder
            loading={props.loading}
            builder={props.builder ? props.builder : "Unknown Builder"}
          />
          <GridCardPrice
            loading={props.loading}
            price={props.price ? props.price : GridCardPriceData}
          />
          <GridCardAreaAndConfig
            loading={props.loading}
            area={props.area ? props.area : GridCardAreaData}
            areaType={props.areaType ? props.areaType : "built_up_area"}
            areaUnit={props.areaUnit ? props.areaUnit : "ft"}
            unitIcon={
              props.unitIcon
                ? props.unitIcon
                : "/images/icons/property/building.svg"
            }
            config={props.bhk ? props.bhk : GridCardConfigData}
            bhk={props.bhk ? props.bhk : GridCardBHKData}
          />
          <GridCardChips
            loading={props.loading}
            chips={props.chips ? props.chips : GridCardChipsData}
          />
          <GridCardButtons
            loading={props.loading}
            shareButtonClickListener={
              typeof props.shareButtonClickListener === "function"
                ? props.shareButtonClickListener
                : shareButtonClickListener
            }
            pdfButtonClickListener={
              typeof props.pdfButtonClickListener === "function"
                ? props.pdfButtonClickListener
                : pdfButtonClickListener
            }
            pdfHref={props.pdfHref ? props.pdfHref : "/pdf/placeholder.pdf"}
            title={props.title ? props.title : "Unknown Property"}
          />
        </div>
      </Link>
    </React.Fragment>
  );
};

export default GridCard;
